import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { useSearchParams } from "react-router-dom"
import { getListSekolah } from "@/services/getData"

export default function MasterSekolahPage() {
  const [searchParams] = useSearchParams()
  const pageParams = searchParams.get("page")
  const rowsPerPageParams = searchParams.get("rowsPerPage")
  const searchQueryParams = searchParams.get("search")

  const { data, isPending } = useQuery({
    queryKey: ["listSekolah", pageParams, rowsPerPageParams, searchQueryParams],
    queryFn: () =>
      getListSekolah(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string
      ),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  )
}
